export default {
    state: {
        currentMembership: null,
    },
    mutations: {
        setCurrentMembership(state, membership) {
            state.currentMembership = membership;
        }
    },
    getters: {
        currentMembership(state) {
            return state.currentMembership;
          },
    },
    actions: {
        storeCurrentMembership({ commit }, membership) {
            commit('setCurrentMembership', membership);
        }
    },
  };
  